import { CenterProps } from './Types'
import Styles from './MobileTopBarContainer.module.scss'

export const Center = ({ children, ...props }: CenterProps) => {
  return (
    <div className={Styles.center} data-theme={props['data-theme']}>
      {children}
    </div>
  )
}
